import {FC} from 'react'
import SuperAdmin_User from './SuperAdmin_User'
import SuperAdminUser from './SuperAdminUser'

const SuperAdminWrapper: FC = () => {
    // const intl = useIntl()
     return (
       <>
         {/* <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.HOME'})}</PageTitle> */}
         {/* <SuperAdmin_User /> */}
         <SuperAdminUser/>
       </>
     )
   }

   export default SuperAdminWrapper